<div class="navbar-vertical">
  <div class="navbar-header">
    <button mat-button class="toggle-button-navbar mat-icon-button" (click)="toggleSidebarFolded()" fxHide.lt-lg>
      <mat-icon [svgIcon]="getSidebarFoldedIcon()"></mat-icon>
    </button>
    <button mat-button class="toggle-button-navbar mat-icon-button arrow-back-button" (click)="toggleSidebarOpened()" fxHide.gt-md>
      <mat-icon svgIcon="arrow_back"></mat-icon>
    </button>
  </div>

  <div class="navbar-content" linPerfectScrollbar>
    <lin-navigation [navigation]="navigation"></lin-navigation>
  </div>
</div>
